import mixpanel from 'mixpanel-browser';
import { createContext, useContext, useEffect, useState } from 'react';

const MixpanelContext = createContext();

export const MixpanelProvider = ({ children }) => {
  const [isIdentified, setIsIdentified] = useState(false);
  const [userId, setUserId] = useState(null);
  const [isEnabled, setIsEnabled] = useState(false);
  useEffect(() => {
    // Skip tracking for staging environment
    const isStaging = import.meta.env.VITE_ENV === 'STAginG_Avoided';
    // FIXME: PLEASE REMOVE THIS HACK @Sujadk
    if (isStaging) {
      console.log('Mixpanel tracking disabled in staging environment');
      setIsEnabled(false);
      return;
    }

    setIsEnabled(true);
    mixpanel.init(import.meta.env.VITE_MIXPANEL_TOKEN, {
      ignore_dnt: true,
      debug: import.meta.env.NODE_ENV !== 'production',
    });
  }, []);

  // Track module-based events with consistent structure
  const trackEvent = (module, properties = {}) => {
    if (!isEnabled) return;
    // Standard properties that should be included in all events
    const standardProps = {
      timestamp: new Date().toISOString(),
    };

    // User identification props when available
    const userProps = isIdentified && userId ? { user_id: userId } : {};

    // Combine all properties with standard format
    const enhancedProps = {
      ...standardProps,
      ...userProps,
      ...properties,
      module, // Added module as a property for easier filtering
    };

    // If event_name is provided in properties, use it, otherwise use the module
    const eventName = properties.event_name || module;

    mixpanel.track(eventName, enhancedProps);
  };

  const identifyUser = (userId, properties = {}) => {
    if (!isEnabled) return;
    mixpanel.identify(userId);
    mixpanel.people.set({
      ...properties,
      $last_login: new Date().toISOString(),
    });
    setIsIdentified(true);
    setUserId(userId);
  };

  const aliasUser = (anonymousId, userId) => {
    if (!isEnabled) return;
    mixpanel.alias(userId, anonymousId);
    setIsIdentified(true);
    setUserId(userId);
  };
  const resetUser = () => {
    if (!isEnabled) return;
    mixpanel.reset();
    setIsIdentified(false);
    setUserId(null);
  };
  return (
    <MixpanelContext.Provider
      value={{ trackEvent, identifyUser, aliasUser, resetUser, isIdentified, userId }}
    >
      {children}
    </MixpanelContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useMixpanel = () => useContext(MixpanelContext);
